<template>
  <Modal class="mask" class-name="vertical-center-modal" v-model="show" :mask-closable="false"  @on-ok="save" :loading="loading">
    <div slot="header" class="modal-header">历史信息</div>

    <div class="records">
      <div>
        <h3>商机记录</h3>
        <span class="fr">自如信用分</span>
      </div>
      <div class="records-list">
      <ul>
        <li>
          <div>自如寓 | 北京将府自如寓<span>4889-5499/月</span> <span  class="fr">待带看</span></div>
          <div>商机创建时间：2018-04-06 10:30</div>
        </li>
        <li>
          <div>自如寓 | 北京将府自如寓<span>4889-5499/月</span> <span  class="fr">待带看</span></div>
          <div>商机创建时间：2018-04-06 10:30</div>
        </li>
      </ul>
      </div>
      <p class="fr tip">仅展示1月内最多3条记录</p>

    </div>
    <div class="rent-records">
      <div>
        <h3>商机记录</h3>
        <span class="fr">自如信用分</span>
      </div>
      <div class="records-list">
        <ul>
          <li>
            <div>自如寓 | 北京将府自如寓<span>4889-5499/月</span> <span  class="fr">待带看</span></div>
            <div>商机创建时间：2018-04-06 10:30</div>
          </li>
          <li>
            <div>自如寓 | 北京将府自如寓<span>4889-5499/月</span> <span  class="fr">待带看</span></div>
            <div>商机创建时间：2018-04-06 10:30</div>
          </li>
        </ul>
        <p>最近一次合同逾期记录：逾期3次，最长逾期7天，平均逾期时长2天！</p>
      </div>
      
      <p class="fr tip">仅展示1月内最多3条记录</p>

    </div>
    <div slot="footer"></div>
  </Modal>
</template>
<script type="text/ecmascript-6">

export default {
  props:{
    n:{
      type:Number,
      default:0
    },
    zoList:{
      type:Array,
      default:()=>{
        return []
      }
    }
  },
  components: {
          
    },
  data () {
  return {
    show:false,
    loading:true
    
 };
 },
 watch:{
   n(val){
     this.show = true;

   }
 },
 methods:{
   changeLoading() {
      this.loading = false;
      this.$nextTick(() => {
          this.loading = true
      })
  },
   save(){

    let params = this.$refs['formData'].validate();
    if(!params){
      this.changeLoading()
      return
    }
    console.log('save')
   
   }
 }
}
</script>
<style lang="css" scoped>
.vertical-center-modal{
  display: flex;
  align-items: center;
  justify-content: center;
}
.vertical-center-modal .ivu-modal{
  top: 0;
}
.records {
  padding-bottom: 30px;
}
h3 {
  display: inline-block;
}
span{
  padding-left:16px;
}
.records-list{
  margin-top: 20px;
  
  padding: 12px;

}
.records .records-list {
  background: #eee;
}
.rent-records .records-list {
  border: 1px solid #eee;
}
li {
  margin-bottom: 20px;
  line-height: 2;
}
.tip {
  line-height: 2;
}



</style>

